<ng-container *rxLet="state$ as localState">
  @if (localState.ribbon.show) {
    <div
      [class]="{ folded: localState.ribbon.folded }"
      class="cv-parse-ribbon-container typography-paragraph max-md:flex max-md:flex-start-center max-md:w-full"
      data-test-id="cv-parse-ribbon-container"
    >
      <!-- PARSING_STATE.PARSING or PARSING_STATE.UPLOADING -->
      @if (localState.parsingState === PARSING_STATE.PARSING || localState.parsingState === PARSING_STATE.UPLOADING) {
        <loader class="inline-block align-middle" color="primary" type="ring" data-test-id="parsing-uploading-loader"></loader>
        <div class="foldable inline-block align-middle max-md:flex max-md:w-full" data-test-id="parsing-uploading-ribbon">
          <div class="ribbon-text inline-block">
            @if (localState.cancelParsing.loading) {
              Cancelling<span class="dots-animated"></span>
            } @else if (localState.parsingState === PARSING_STATE.PARSING) {
              Parsing CV<span class="dots-animated"></span>
            } @else if (localState.parsingState === PARSING_STATE.UPLOADING) {
              Uploading CV<span class="dots-animated"></span>
            }
          </div>

          <button
            [class]="{
              'button-folded': localState.cancelParsing.loading || localState.parsingState === PARSING_STATE.UPLOADING,
            }"
            [disableRipple]="true"
            (click)="cancelParsing()"
            class="small-button inline-block align-middle cancel-button"
            color="primary"
            mat-button
            type="button"
          >
            Cancel
          </button>
        </div>

        <mat-icon
          [svgIcon]="localState.ribbon.folded ? 'chevron_right' : 'chevron_left'"
          (click)="foldToggle()"
          class="fold-toggle-button inline-block align-middle max-md:hidden"
        ></mat-icon>

        @if (localState.parsingState !== PARSING_STATE.UPLOADING) {
          <mat-icon
            (click)="cancelParsing()"
            class="close-button align-middle hidden max-md:inline-block max-md:justify-self-end"
            svgIcon="close"
          ></mat-icon>
        }
      }
      <!-- PARSING_STATE.SUCCESS -->
      @if (localState.parsingState === PARSING_STATE.PARSED_SUCCESS) {
        <div class="foldable align-middle max-md:flex max-md:w-full max-md:flex-between-start" data-test-id="parsing-success-ribbon">
          <div class="inline-block align-middle">
            <mat-icon class="inline-block align-middle state-icon" color="accent" fontIcon="check_circle"></mat-icon>
            <div class="ribbon-text inline-block">Parsing Successful</div>
            <button
              [disableRipple]="true"
              [routerLink]="parsedCvUrl + localState.parsingResult.cvId"
              (click)="resetParsing()"
              class="small-button inline-block align-middle view-cv-button"
              color="primary"
              mat-button
              type="button"
            >
              View CV
            </button>
          </div>
          <mat-icon (click)="resetParsing()" class="close-button inline-block align-middle" svgIcon="close"></mat-icon>
        </div>
      }
      <!-- PARSING_STATE.ERROR -->
      @if (localState.parsingState === PARSING_STATE.PARSED_ERROR) {
        <div class="foldable align-middle max-md:flex max-md:w-full max-md:flex-between-start" data-test-id="parsing-error-ribbon">
          <div class="inline-block align-middle">
            <mat-icon class="inline-block align-middle state-icon" color="warn" fontIcon="cancel"></mat-icon>
            <div class="ribbon-text inline-block">Parsing Failed</div>
          </div>
          <mat-icon (click)="resetParsing()" class="close-button inline-block align-middle" svgIcon="close"></mat-icon>
        </div>
      }
      <!-- PARSING_STATE.CANCELLED -->
      @if (localState.parsingState === PARSING_STATE.CANCELLED) {
        <div class="foldable align-middle max-md:flex max-md:w-full max-md:flex-between-start" data-test-id="parsing-cancelled-ribbon">
          <div class="inline-block align-middle">
            <mat-icon class="inline-block align-middle state-icon" color="warn" fontIcon="cancel"></mat-icon>
            <div class="ribbon-text inline-block">Parsing Canceled</div>
          </div>
          <mat-icon
            (click)="resetParsing()"
            class="close-button inline-block align-middle max-md:justify-self-end"
            svgIcon="close"
          ></mat-icon>
        </div>
      }
    </div>
  }
</ng-container>
